export default __webpack_public_path__ + "images/up-double-arrow.svg";